export default __webpack_public_path__ + "static/media/Transfer_Money.567252c2.png";